import React, { useEffect, useRef, useState } from 'react';
import UseStateContext from '../session/UseStateContext';
import { countTestDrivesOfExhibitor } from '../../common/ApiService';

const CHECK_INTERVAL_MS = 3 * 60 * 1000; // TODO: revert to 60 * 60 * 1000 (1 hour)

const msUntilNextFullHour = () => {
    const now = new Date();
    const next = new Date(now);
    next.setMinutes(0, 0, 0);
    next.setHours(now.getHours() + 1);
    return next.getTime() - now.getTime();
};

/**
 * At the top of every hour (12:00, 13:00, 14:00, ...), checks whether the
 * logged-in (non-admin) exhibitor has any test drives yet. If not, shows a
 * popup reminding them to contact support.
 */
const NoTestDrivesAlert = () => {
    const { context } = UseStateContext();
    const { loggedIn, exhibitor } = context;
    const [showAlert, setShowAlert] = useState(false);
    const abortControllerRef = useRef(null);

    useEffect(() => {
        if (!loggedIn || !exhibitor?.id || exhibitor.isAdmin) {
            return;
        }

        const checkTestDrives = async () => {
            abortControllerRef.current = new AbortController();
            try {
                const count = await countTestDrivesOfExhibitor(exhibitor.id, abortControllerRef.current.signal);
                if (count === 0) {
                    setShowAlert(true);
                }
            } catch (error) {
                // ignore cancelled/failed checks, try again next hour
            }
        };

        let intervalId;
        const timeoutId = setTimeout(() => {
            checkTestDrives();
            intervalId = setInterval(checkTestDrives, CHECK_INTERVAL_MS);
        }, 3 * 60 * 1000); // TODO: revert to msUntilNextFullHour()

        return () => {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
            abortControllerRef.current?.abort();
        };
    }, [loggedIn, exhibitor?.id, exhibitor?.isAdmin]);

    if (!showAlert) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            }}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    padding: '30px',
                    borderRadius: '10px',
                    maxWidth: '500px',
                    textAlign: 'center',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}
            >
                <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.5' }}>
                    Bis jetzt sind noch keine Testfahrten eingegangen. Bitte wenden Sie sich unter der Telefonnummer 079 346 34 82 an uns.
                </p>
                <button
                    onClick={() => setShowAlert(false)}
                    className="btn btn-primary mt-3"
                    style={{
                        padding: '10px 30px',
                        fontSize: '16px'
                    }}
                >
                    OK
                </button>
            </div>
        </div>
    );
};

export default NoTestDrivesAlert;
